import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Box,
  Tabs,
  Tab,
  Chip,
  IconButton,
  TextField,
  InputAdornment,
  Paper,
  Divider,
} from '@mui/material';
import {
  Search,
  Add,
  Remove,
  Star,
  AccessTime,
  LocalFireDepartment,
  Restaurant,
  LocalPizza,
  LunchDining,
  Icecream,
  LocalCafe,
  BakeryDining,
  SetMeal,
  SoupKitchen,
  PlayArrow,
} from '@mui/icons-material';
import HeroSection from './HeroSection';

const menuCategories = [
  { id: 'all', name: 'All Items', icon: <Restaurant /> },
  { id: 'starters', name: 'Starters', icon: <SetMeal /> },
  { id: 'main', name: 'Main Course', icon: <LunchDining /> },
  { id: 'pizza', name: 'Pizza', icon: <LocalPizza /> },
  { id: 'desserts', name: 'Desserts', icon: <Icecream /> },
  { id: 'beverages', name: 'Beverages', icon: <LocalCafe /> },
];

const menuItems = [
  // Starters
  {
    id: 1,
    category: 'starters',
    name: 'Spring Rolls',
    description: 'Crispy vegetable spring rolls with sweet chili sauce',
    price: 89,
    rating: 4.5,
    prepTime: '15 min',
    spicy: 1,
    vegetarian: true,
    image: 'ruti.png',
    bestseller: true,
    videoUrl: 'https://youtu.be/oAm3TYN83fw?si=Nuf7plpVE54HTMbd',
  },
  {
    id: 2,
    category: 'starters',
    name: 'Paneer Tikka',
    description: 'Marinated paneer cubes grilled to perfection with spices',
    price: 129,
    rating: 4.8,
    prepTime: '20 min',
    spicy: 2,
    vegetarian: true,
    image: 'chiken.png',
  },
  {
    id: 3,
    category: 'starters',
    name: 'Chicken Wings',
    description: 'Spicy chicken wings with tangy BBQ sauce',
    price: 149,
    rating: 4.7,
    prepTime: '25 min',
    spicy: 3,
    vegetarian: false,
    image: 'kfc.png',
    bestseller: true,
  },
  // Main Course
  {
    id: 4,
    category: 'main',
    name: 'Butter Chicken',
    description: 'Tender chicken in rich creamy tomato gravy with butter',
    price: 249,
    rating: 4.9,
    prepTime: '30 min',
    spicy: 2,
    vegetarian: false,
    image: 'beef-ruti.png',
    bestseller: true,
  },
  {
    id: 5,
    category: 'main',
    name: 'Paneer Butter Masala',
    description: 'Soft paneer cubes in creamy butter tomato gravy',
    price: 229,
    rating: 4.8,
    prepTime: '25 min',
    spicy: 1,
    vegetarian: true,
    image: 'ruti.png',
  },
  {
    id: 6,
    category: 'main',
    name: 'Dal Makhani',
    description: 'Creamy black lentils cooked with butter and spices',
    price: 189,
    rating: 4.6,
    prepTime: '35 min',
    spicy: 1,
    vegetarian: true,
    image: 'ruti.png',
  },
  {
    id: 7,
    category: 'main',
    name: 'Biryani',
    description: 'Fragrant basmati rice with aromatic spices and meat',
    price: 279,
    rating: 4.9,
    prepTime: '40 min',
    spicy: 3,
    vegetarian: false,
    image: 'ruti.png',
    bestseller: true,
  },
  // Pizza
  {
    id: 8,
    category: 'pizza',
    name: 'Margherita Pizza',
    description: 'Classic pizza with fresh mozzarella and basil',
    price: 199,
    rating: 4.5,
    prepTime: '20 min',
    spicy: 0,
    vegetarian: true,
    image: 'pizza.png',
  },
  {
    id: 9,
    category: 'pizza',
    name: 'Pepperoni Pizza',
    description: 'Italian pizza with pepperoni and mozzarella cheese',
    price: 249,
    rating: 4.7,
    prepTime: '25 min',
    spicy: 1,
    vegetarian: false,
    image: 'pizza-3.png',
    bestseller: true,
  },
  {
    id: 10,
    category: 'pizza',
    name: 'Veggie Supreme',
    description: 'Loaded with fresh vegetables and cheese',
    price: 229,
    rating: 4.6,
    prepTime: '25 min',
    spicy: 0,
    vegetarian: true,
    image: 'ruti.png',
  },
  // Desserts
  {
    id: 11,
    category: 'desserts',
    name: 'Gulab Jamun',
    description: 'Soft milk dumplings in sugar syrup',
    price: 79,
    rating: 4.8,
    prepTime: '10 min',
    spicy: 0,
    vegetarian: true,
    image: 'ruti.png',
    bestseller: true,
  },
  {
    id: 12,
    category: 'desserts',
    name: 'Ice Cream Sundae',
    description: 'Vanilla ice cream with chocolate sauce and nuts',
    price: 99,
    rating: 4.7,
    prepTime: '5 min',
    spicy: 0,
    vegetarian: true,
    image: 'ruti.png',
  },
  {
    id: 13,
    category: 'desserts',
    name: 'Rasmalai',
    description: 'Soft cottage cheese dumplings in saffron milk',
    price: 89,
    rating: 4.6,
    prepTime: '10 min',
    spicy: 0,
    vegetarian: true,
    image: 'ruti.png',
  },
  // Beverages
  {
    id: 14,
    category: 'beverages',
    name: 'Mango Lassi',
    description: 'Sweet yogurt drink with mango flavor',
    price: 69,
    rating: 4.7,
    prepTime: '5 min',
    spicy: 0,
    vegetarian: true,
    image: 'pasta.png',
  },
  {
    id: 15,
    category: 'beverages',
    name: 'Masala Chai',
    description: 'Spiced Indian tea with milk and sugar',
    price: 49,
    rating: 4.5,
    prepTime: '5 min',
    spicy: 0,
    vegetarian: true,
    image: 'kfc.png',
  }
];

import { MenuItem as MenuItemType, MenuItemData } from '../types';

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`menu-tabpanel-${index}`}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export default function MenuPage() {
  const [selectedCategory, setSelectedCategory] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [cartItems, setCartItems] = useState<{ [key: number]: number }>({});

  // Filter menu items based on selected category and search term
  const filteredItems: MenuItemData[] = menuItems.filter((item: MenuItemData) => {
    const matchesCategory = selectedCategory === 0 || item.category === menuCategories[selectedCategory]?.id;
    const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const handleCategoryChange = (event: React.SyntheticEvent<Element>, newValue: number) => {
    setSelectedCategory(newValue);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const addToCart = (itemId: number) => {
    setCartItems(prev => ({
      ...prev,
      [itemId]: (prev[itemId] || 0) + 1,
    }));
  };

  const removeFromCart = (itemId: number) => {
    setCartItems(prev => {
      const newCart = { ...prev };
      if (newCart[itemId] > 0) {
        newCart[itemId]--;
      }
      return newCart;
    });
  };

  const getTotalItems = () => {
    return Object.values(cartItems).reduce((sum, count) => sum + count, 0);
  };

  const updateQuantity = (itemId: number, change: number) => {
    setCartItems(prev => ({
      ...prev,
      [itemId]: Math.max(0, (prev[itemId] || 0) + change)
    }));
  };

  const getSpicyLevel = (level: number) => {
    return Array.from({ length: 3 }, (_, i) => (
      <LocalFireDepartment
        key={i}
        sx={{
          fontSize: 16,
          color: i < level ? '#d32f2f' : '#e0e0e0',
          mr: 0.5,
        }}
      />
    ));
  };

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <HeroSection title="OUR MENU" description="Discover our delicious selection of authentic dishes" />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Header */}

        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h3" fontWeight={700} color="primary.main" sx={{ mb: 2 }}>
            Our Menu
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            Discover our delicious selection of authentic dishes
          </Typography>

          {/* Search Bar */}
          <Paper
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              maxWidth: 600,
              mx: 'auto',
              mb: 4,
            }}
          >
            <Search sx={{ color: 'text.secondary', mr: 1 }} />
            <TextField
              fullWidth
              placeholder="Search for dishes..."
              variant="standard"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Paper>
        </Box>

        {/* Category Tabs */}
        <Box sx={{ borderBottom: 2, borderColor: 'divider', mb: 4 }}>
          <Tabs
            value={selectedCategory}
            onChange={handleCategoryChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                minWidth: 'auto',
                px: 2,
                textTransform: 'none',
                fontWeight: 500,
              },
            }}
          >
            {menuCategories.map((category) => (
              <Tab
                key={category.id}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {category.icon}
                    {category.name}
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Box>

        {/* Menu Items Grid */}
        <Grid container spacing={3}>
          {filteredItems.map((item: MenuItemData) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                  },
                }}
              >
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={`/assets/images/${item.image}`}
                    alt={item.name}
                  />
                  {item.bestseller && (
                    <Chip
                      label="Bestseller"
                      color="primary"
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        fontWeight: 600,
                      }}
                    />
                  )}
                  {item.vegetarian && (
                    <Chip
                      label="Veg"
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        bgcolor: '#4caf50',
                        color: 'white',
                        fontWeight: 600,
                      }}
                    />
                  )}
                </Box>

                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {item.name}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {item.description}
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Star sx={{ color: '#ffc107', fontSize: 16, mr: 0.5 }} />
                      <Typography variant="body2" fontWeight={500}>
                        {item.rating}
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <AccessTime sx={{ fontSize: 16, mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="body2" color="text.secondary">
                        {item.prepTime}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {getSpicyLevel(item.spicy)}
                  </Box>

                </CardContent>


              </Card>
            </Grid>
          ))}
        </Grid>

        {filteredItems.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h6" color="text.secondary">
              No items found matching your search.
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
}
